import { useSelector } from 'react-redux';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { getTakeoverExperimentData } from 'modules/experiments/ducks/selectors';
import { StyledWinningCriteriaSectionHeader } from '../styled';
import {
  ReadOnlySettingsWrapper,
  StyledSettingsFieldValue,
  StyledSettingsFormField,
} from './Styled';

export const WinningCriteriaSettings = () => {
  const { t } = useExperimentsTranslations();
  const experimentData = useSelector(getTakeoverExperimentData);

  return (
    <>
      <StyledWinningCriteriaSectionHeader>
        {t('settings.winningCriteria.header')}
      </StyledWinningCriteriaSectionHeader>
      <ReadOnlySettingsWrapper>
        <StyledSettingsFormField
          labelText={t('settings.winningMetricSettings.winningMetric')}
          isHorizontalLayout
        >
          <StyledSettingsFieldValue>{experimentData.winningCriteria.name}</StyledSettingsFieldValue>
        </StyledSettingsFormField>
      </ReadOnlySettingsWrapper>
    </>
  );
};
